import styled, {css} from "styled-components";
import themeResponsiveProperty from "../responsive/themeResponsiveProperty";

export default styled.div`
  border-radius: .3125rem;
  background-color: #41a4ff;
  color: #FFF;
  padding: 0 .625rem;
  line-height: 1.125rem;
  font-size: .625rem;
  text-transform: uppercase;
  font-family: 'Din-Medium', sans-serif;
`;
